// product-card-refresh.js

// variant selection for product-card popup
document.addEventListener('click', e => {
  const selectEl = e.target.closest('.product-card-refresh input.product-selector__select');
  if (!selectEl) return;

  var $container = $(selectEl).closest(".product-card--variants");

  var currentOptions = $container
    .find("input[data-single-option-selector]")
    .map((index, element) => {
      var $element = $(element);
      var type = $element.attr("type");
      var currentOption = {};

      //console.log($element, type, currentOption);

      if (type === "radio" || type === "checkbox") {
        if ($element[0].checked) {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");

          console.log("checked", $element.val(), currentOption.index);
          return currentOption;
        } else {
          return false;
        }
      } else {
        currentOption.value = $element.val();
        currentOption.index = $element.data("index");
        return currentOption;
      }
    });

  // remove any unchecked input values if using radio buttons or checkboxes
  currentOptions = slate.utils.compact(currentOptions);
  console.log("currentOptions", currentOptions);

  var productObject = JSON.parse(
    $("[data-product-json]", $container).html()
  );

  var variants = productObject.variants;

  console.log("variants", variants);

  var found = false;

  variants.forEach(function (variant) {
    var satisfied = true;

    currentOptions.forEach(function (option) {
      if (satisfied) {
        satisfied = option.value == variant[option.index];
      }
    });

    if (satisfied) {
      found = variant;
    }
  });

  if (
    productObject.tags.indexOf("wallet_go_combined") &&
    found.title.includes("Groove Wallet Go")
  ) {
    var quickshopArray = "";

    // base money clip wallet ID
    if (productObject.title.includes("Gun Metal")) {
      quickshopArray += "40538108100675";
    } else {
      quickshopArray += "40538058817603";
    }

    // Groove Wallet Go ID
    if (found.title.includes("Brown Leather")) {
      quickshopArray += ", 40506842742851";
    } else if (found.title.includes("Black Leather")) {
      quickshopArray += ", 40506842775619";
    }

    $container
      .closest(".product-card-refresh")
      .find(".product-card--button button")
      .attr("data-quickshop", quickshopArray);
  } else if (found.available) {
    $container
      .closest(".product-card-refresh")
      .find(".product-card--button button")
      .attr("data-quickshop", found.id);
  }
});

window.addEventListener("load", function () {
  function initProductCards() {
    var selectors = {
      productCardSlider: ".product-card-refresh [data-product-card-slider]",
      photoPrev: ".product-card-refresh [data-photo-prev]",
      photoNext: ".product-card-refresh [data-photo-next]",
    };

    var initProductSliders = function () {
      $(selectors.productCardSlider).each(function (index) {
        if ($(this).hasClass("slick-initialized")) return;

        var options = {
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          dots: true,
        };

        $(this).slick(options);
      });
    };

    initProductSliders();

    $(".product-card-refresh .product-card--variants .close").off("click");
    $(".product-card-refresh .product-card--variants .close").click(
      function () {
        console.log("close variants");
        var $container = $(this).closest(".product-card--variants");
        $container.removeClass("active");
        $container
          .closest(".product-card-refresh")
          .find(".product-card--button button")
          .removeAttr("data-ready-to-add")
          .text("Quick add");
      }
    );

    // sizing modals
    $(
      ".product-card-refresh .whats_my_size_trigger, .product-card-refresh .whats_my_size_modal .x-close"
    ).off("click");
    $(
      ".product-card-refresh .whats_my_size_trigger, .product-card-refresh .whats_my_size_modal .x-close"
    ).click(function () {
      console.log("toggle modal", $(this).closest(".sizing-guide-modal"));
      $(this)
        .closest(".sizing-guide-modal")
        .find(".whats_my_size_modal")
        .toggleClass("hidden");
    });

    $(".product-card-refresh .whats_my_size_modal").off("click");
    $(".product-card-refresh .whats_my_size_modal").click(function (event) {
      console.log("close", event.target);
      if (
        !$(event.target).closest(".whats_my_size_modal > div").length &&
        !$(event.target).is(".whats_my_size_modal > div")
      ) {
        $(this).addClass("hidden");
      }
    });
  }

  if ($(".product-card-refresh").length > 0) {
    initProductCards();
  }
});